// extracted by mini-css-extract-plugin
module.exports = {"text":"verify_lawyer_modal_validated-module__text--JSeDK","button":"verify_lawyer_modal_validated-module__button--tkdko"};